import { useState, useEffect } from 'react';

interface AnimatedValueProps {
  value: number;
  delay?: number;
  animate: boolean;
}

export function AnimatedValue({ value, delay = 0, animate }: AnimatedValueProps) {
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!animate) { setDisplay(0); return; }
    const timer = setTimeout(() => {
      const start = performance.now();
      const tick = (now: number) => {
        const progress = Math.min((now - start) / 900, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        setDisplay(Math.round(eased * value));
        if (progress < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }, delay);
    return () => clearTimeout(timer);
  }, [animate, value, delay]);

  return <span>{display}</span>;
}
